export default function home_bio() {
	
	$('.block-bio .info-readmore a').magnificPopup({
    items: {
      src: '#about-content',
      type: 'inline'
    }
  });
	
}